import React from 'react'

const ClassTable = props => (
  <table>
    <thead>
      {props.data.headings.map(header => (
        <th align="left">{header}</th>
      ))}
    </thead>
    <tbody>
      {props.data.data.map(data => (
        <tr>
          <td className="nowrap">
            <span className="table__code">{data.class}</span>
          </td>
          <td>{data.type}</td>
          <td className="nowrap">
            <span className="table__code">{data.css}</span>
          </td>
          <td className="table__description">{data.description}</td>
        </tr>
      ))}
    </tbody>
  </table>
)

export default ClassTable
